<template>
  <div v-if="hotspot.url" class="hotspot">
    <a
      :href="hotspot.url"
      target="_blank"
      rel="noopener noreferrer"
      class="allow-touch hotspot-link"
      @click="createStatistic"
    >
      <span class="hotspot-circle">
        <BaseIcon icon="link" class="size-16 allow-touch" />
      </span>
    </a>
  </div>
</template>

<script setup lang="ts">
import {
  type HotspotLinkEntity,
  HotspotStatisticsType,
  useCreateHotspotStatisticMutation,
} from "~/graphql/generated";

const props = defineProps<{
  hotspot: HotspotLinkEntity;
}>();

const x = ref(`${props.hotspot.x * 100}%`);
const y = ref(`${props.hotspot.y * 100}%`);
const width = ref(`${props.hotspot.width * 100}%`);
const height = ref(`${props.hotspot.height * 100}%`);

// Hotspot statistics mutation
const deviceId = useDeviceId();
const hotspotStatisticMutation = useCreateHotspotStatisticMutation();
const createStatistic = () => {
  hotspotStatisticMutation.executeMutation({
    createHotspotStatistic: {
      deviceId: deviceId.value,
      hotspotId: props.hotspot.id,
      statisticsType: HotspotStatisticsType.LinkClick,
    },
  });
};
</script>

<style lang="scss" scoped>
.hotspot {
  position: absolute;
  z-index: 4;
  left: v-bind("x");
  top: v-bind(y);
  width: v-bind(width);
  height: v-bind(height);

  .hotspot-link {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .hotspot-circle {
      width: 26px;

      aspect-ratio: 1/1;
      color: white;
      background-color: rgba($dark-100, 0.75);
      border-radius: 100%;

      display: flex;
      align-items: center;
      justify-content: center;

      cursor: pointer;
    }
  }
}
</style>
